import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const petSlice = createSlice({
  name: "pet",
  initialState,
  reducers: {
    setPet(state, action) {
      state.pet = action.payload;
    }
  }
});

const { actions, reducer } = petSlice;

export const { setPet } = actions;

export const setPetAction = (data) => async (dispatch) => {
  dispatch(setPet(data));
};

export default reducer;
